import { getDisplayAssetCode } from '@altify/utils';
import { Pressable, View } from 'react-native';
import { twMerge } from 'tailwind-merge';
import { DropdownIcon } from '../../Icons';
import { Typography } from '../../Text';
import { AssetFieldSelectorProps } from '../AssetField.types';

const positions = {
  left: 'rounded-tl-2xl rounded-bl-2xl',
  right: 'rounded-br-2xl rounded-tr-2xl',
} as const;

const states = {
  default: 'border border-neutral-600 hover:enabled:border-prim-electric-blue',
  focused: 'border-2 border-prim-electric-blue',
  error: 'border-2 border-error',
} as const;

const AssetFieldSelector = ({
  onPress,
  tag,
  state = 'default',
  position = 'full',
  className,
  selectedAssetCode,
  placeholder = '-',
  iconComponent: IconComponent,
  iconProps,
  backgroundColor = 'bg-app-background',
  showDropdownIcon = true,
  disabled = false,
}: AssetFieldSelectorProps) => {
  const border = states[state];
  const radius = position !== 'full' ? positions[position] : 'rounded-2xl';
  const value =
    selectedAssetCode == null
      ? placeholder
      : getDisplayAssetCode(selectedAssetCode);
  return (
    <Pressable
      onPress={onPress}
      role="button"
      disabled={disabled}
      className={twMerge(
        'h-[56px] min-w-28 justify-center active:enabled:opacity-20 bg-neutral-800 p-4',
        radius,
        border,
        className
      )}
    >
      <View
        className={twMerge(
          'absolute top-0 left-0 ml-3 mt-[-12px] bg-app-background px-1 rounded-b-sm h-[12px]',
          backgroundColor
        )}
      >
        <Typography
          weight="regular"
          variant="body"
          size="medium"
          className="text-white px-1 rounded-b-sm h-[20px] w-full"
        >
          {tag}
        </Typography>
      </View>
      <View className={twMerge('flex-row items-center')}>
        {selectedAssetCode != null && IconComponent && (
          <IconComponent {...iconProps} className="mr-2" />
        )}
        <Typography
          variant="body"
          weight="medium"
          size="large"
          className={twMerge('text-white mr-1 grow')}
        >
          {value}
        </Typography>
        {showDropdownIcon && <DropdownIcon stroke="white" />}
      </View>
    </Pressable>
  );
};

export default AssetFieldSelector;
